exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-transition-preview-exit-wrapper-lYJmE{pointer-events:none}.index-transition-preview-enter-wrapper-15SJH,.index-transition-preview-exit-wrapper-lYJmE{position:absolute;left:0;top:0;width:100%;height:100%}", ""]);

// Exports
exports.locals = {
	"transition-preview-exit-wrapper": "index-transition-preview-exit-wrapper-lYJmE",
	"transition-preview-enter-wrapper": "index-transition-preview-enter-wrapper-15SJH"
};